<div class="button-container">
    <button mat-raised-button color="primary" (click)="doBinderAudit()">
        <mat-icon fontSet="material-symbols-outlined">auto_stories</mat-icon>
        Binder Audit
    </button>
</div>

<div class="button-container">
    <button mat-raised-button color="primary" (click)="doLoseCardAudit()">
        <mat-icon fontSet="material-symbols-outlined">inventory_2</mat-icon>
        Loose Card Audit
    </button>
</div>

<div class="button-container">
    <button mat-raised-button color="primary" (click)="doCollatedSetAudit()">
        <mat-icon fontSet="material-symbols-outlined">style</mat-icon>
        Collated Set Audit
    </button>
</div>

<div class="button-container">
    <button mat-raised-button color="secondary" (click)="cancel()">
        Cancel
    </button>
</div>